import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGoogleAuthenticationMutation } from "../redux/features/auth/auth.api";
import { authSliceActions } from "../redux/features/auth/auth.slice";
import { useAppDispatch } from "../redux/hooks";
import { resumeUrlKey } from "../utils/constants";
import { useActionExecutor } from "./useActionExecutor";

export const useSocialAuth = () => {
  const [searchParams] = useSearchParams();

  const { executeAction } = useActionExecutor();

  const [
    googleAuth,
    {
      isLoading: authenticatingWithGoogle,
      isError: isGoogleAuthError,
      error: googleAuthError,
    },
  ] = useGoogleAuthenticationMutation();

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const loginWighGoogle = useGoogleLogin({
    flow: "implicit",
    onSuccess: async (tokenResponse) => {
      const response = await googleAuth({
        authToken: tokenResponse.access_token,
        referralId: searchParams?.get("ref") || undefined,
      });

      if (response.data?.status === "success") {
        dispatch(
          authSliceActions.signUserIn({
            profile: {
              ...response.data.data,
            },
            token: response.data.data.token,
          }),
        );

        executeAction(
          response.data.data._id,
          response.data.data.email,
          searchParams?.get("eventId") ?? "",
        );

        const resumeUrl = localStorage.getItem(resumeUrlKey);

        if (resumeUrl) {
          navigate(resumeUrl);
          localStorage.removeItem(resumeUrlKey);
        } else {
          navigate("/home");
        }
      }
    },
  });

  return {
    loginWighGoogle,
    authenticatingWithGoogle,
    googleAuthError,
    isGoogleAuthError,
  };
};
